import {
  AA_BRAND_DISPLAY_NAME,
  BSM_BRAND_DISPLAY_NAME,
} from "@ds-developer/constants";
import { Brand } from "@hubcapp/types";

export const getBrandDisplayName = (brand: Brand) => {
  if (brand === Brand.Aads) {
    return AA_BRAND_DISPLAY_NAME;
  }

  return BSM_BRAND_DISPLAY_NAME;
};
